import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable, Subject} from 'rxjs';
import {Api} from '../enum/Api';
import {CustomerCreditCard} from '../model/customer-credit-card';
import {environment} from '../../../environments/environment';

declare var bpSop_silentOrderPost: any;

interface SilentOrderSuccessResponse {
  PaymentToken: string;
  ForeignCard: string;
  BinQueryReturnCode: string;
  BinQueryReturnMessage: string;
  Brand: string;
}

/** Resposta de erro da geração de token de pagamento.  */
export interface SilentOrderErrorResponse {
  Text: string;
  Code: string;
}

export interface SilentOrderInvalidResponse {
  Field: string;
  Message: string;
}


export interface SilentOrderRequest {
  accessToken: string;
  onSuccess: ((e: any) => any);
  onError: ((e: SilentOrderErrorResponse) => any);
  onInvalid: ((e: SilentOrderErrorResponse) => any);
  environment: string;
  language: string;
}


@Injectable()
export class SilentOrderService {

  public accessToken: string = null;
  public accessTokenGenerationDate: string = null;
  public paymentToken: string = null;

  private silentOrderFieldMap: object = {

    'bp-sop-cardnumber': 'Número do Cartão',
    'bp-sop-cardholdername': 'Nome escrito no cartão',
    'bp-sop-cardexpirationdate': 'Data de validade (mês/ano)',
    'bp-sop-cardcvv': 'Código de segurança'
  };
  public silentOrderError: Subject<any> = new Subject<any>();
  public silentOrderInvalidCard: Subject<any> = new Subject<any>();
  public paymentTokenGenerated: Subject<any> = new Subject<any>();

  constructor(private httpService: HttpService) {  }



  ///////////////////////////////

  /** Ações ao receber a resposta do silent order. */
  private onSuccess(response: SilentOrderSuccessResponse) {
    this.paymentToken = response.PaymentToken;
    this.paymentTokenGenerated.next(this.paymentToken);
    console.error(JSON.stringify(response));
  }

  private onError(error: SilentOrderErrorResponse): void {
    console.error(JSON.stringify(error));
    this.silentOrderError.next(error);
  }

  private onInvalid(error: Array<SilentOrderInvalidResponse>): void {
    error.forEach(
      (err: SilentOrderInvalidResponse) => {
        err.Message = `Campo ${this.silentOrderFieldMap[err.Field]} ${err.Message}.`;
      }
    );
    this.silentOrderInvalidCard.next(error);
  }

  ///////////////////////////////

  /**
   * Função responsável por retornar o token de acesso para o silent order post da braspag
   */
  getAccessToken(): Observable<any> {
    return this.httpService.post('billing/accountPaymentData/getAccessToken', Api.One_Portal, null);
  }

  generatePaymentToken(creditCard: CustomerCreditCard) {
    this.getAccessToken().subscribe((response: any) => {
      if (response.accessToken) {
        this.accessToken = response.accessToken;
        this.accessTokenGenerationDate = response.expiresIn;
        const options = this.buildSilentOrderParams(creditCard);
        bpSop_silentOrderPost(options);
      }
    });
  }

  buildSilentOrderParams(creditCard: CustomerCreditCard): SilentOrderRequest {

    this.pushDataToHTML(creditCard);

    return {
      accessToken: this.accessToken,
      onSuccess: this.onSuccess.bind(this),
      onError: this.onError.bind(this),
      onInvalid: this.onInvalid.bind(this),
      environment: environment.silent_order_enviroment,
      language: 'PT'
    };
  }


  /**
   * Adiciona os dados do cartão do cliente ao html para ser
   * encontrado pelo silent order.
   * @param creditCard cartão de crédito informado pelo usuário
   */
  private pushDataToHTML(creditCard: CustomerCreditCard) {
    function append(innerHtml: string) {
      const elem = document.getElementById('silentOrderInputs');
      elem.innerHTML = innerHtml;
    }

    const newHtml = `
        <input type="text" class="bp-sop-cardholdername "  value="${creditCard.cardHolder}" />
        <input type="text" class="bp-sop-cardnumber " value="${creditCard.cardNumber.split(' ').join('')}" />
        <input type="text" class="bp-sop-cardexpirationdate"  value="${this.getExpirationDateFormatted(creditCard.cardValidityDate)}" />
        <input type="text" class="bp-sop-cardcvv" value="${creditCard.cardSecurityCode}" />
        `;

    append(newHtml);
  }

  private getExpirationDateFormatted(dateString: string): string {
    let date = dateString.split('/');
    return date[0] + '/20' + date[1];
  }
}
